module.exports = __webpack_public_path__ + "assets/feedbackicon-6.a7bd112e.svg";